// extracted by mini-css-extract-plugin
export default {"axis":"graph__axis___sa--k","hidden":"graph__hidden___V1LqS"};